module.exports = __webpack_public_path__ + "images/stickers/rocketship.484099c2f7dfcfe5fef9.png";